// extracted by mini-css-extract-plugin
export default {"stake":"_3enQr","disabledIcon":"BlxDC","betPrice":"_26WNZ"};